<template>
  <div class="links" :style="{ height: (contenitoreHeight)+ 'px'}">
    <div class="col-24 links-title">
      <span>{{ $i18n.t('links.title') }}</span>
    </div>
    <div class="gridLinks" v-loading="loading">
      <div v-for="link in links" class="col-24 no-padding link-row" :key="link.titolo" >
        <div class="link-row" @click="openUrl(link.url)">
          <div class="icon">
            <icon name="riv-www" scale="1.5"></icon>
          </div>
          <div class="testo">
            <span class="link-url">{{link.titolo}}</span>
            <span class="link-name"> ({{link.url}})</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DocsHeader from '../Documenti/DocsHeader.vue'

  export default {
    components: {DocsHeader},
    name: 'links',
    props: ['contenitoreHeight'],
    i18n: {
      messages: {
        it_IT: {
          links: {
            title: 'Link utili'
          }
        },
        fr_FR: {
          links: {
            title: 'Liens utiles'
          }
        },
        es_ES: {
          links: {
            title: 'Enlaces útiles'
          }
        },
        de_DE: {
          links: {
            title: 'Nützliche Links'
          }
        },
        en_GB: {
          links: {
            title: 'Useful Links'
          }
        }
      }
    },
    data () {
      return {
        links: [],
        loading: false,
      }
    },
    computed: {
      homeStyle: function () {
        let path = this.$route.path
        return (path.indexOf('/app/links') !== 0)
      }
    },
    mounted: function () {
      this.loadDocs()
    },
    methods: {
      loadDocs: function () {
        this.loading = true
        this.$http.get('dipendente/' + this.$store.state.country + '/link').then(response => {
          if (response.body.rc === 0) {
            this.links = response.body.data
            this.loading = false
          //} else {
          //  this.$router.push({name: 'Login'})
          }
        }, response => {
          //this.$router.push({name: 'Login'})
        })
      },
      openUrl: function (url) {
        let win = window.open(url, '_blank')
        win.focus()
      },
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .links {
    height: 100%;
    padding-bottom: 10px;
    overflow: auto;
    .links-title {
      padding-left: 10px;
      padding-right: 10px;
      width: 100%;
      height: 40px;
      text-align: center;
      margin-bottom: 20px;
      span {
        line-height: 40px;
        height: 40px;
        text-align: center;
        width: calc(100% - 50px);
        .set-font(@color: @rossoRiva, @size: 20px, @family: 'os-regular');
        font-weight: bold;
        letter-spacing: 2px;
        text-transform: uppercase;
        height: 40px;
        letter-spacing: 2px;
        padding-top: 10px;
      }
      /*span {
        display: block;
        text-align: left;
        letter-spacing: 3px;
        text-transform: uppercase;
        .set-font(@size: 16px, @color: @greenRiva, @weight: bold, @family:'os-regular');
      }*/
    }
    .gridLinks {
      padding-left: 10px;
      padding-right: 10px;
      overflow: auto;
      height: calc(100% - 65px);
      .link-row {
        height: 50px;
        margin-bottom: 15px;
        .icon {
          width: 30px;
          float: left;
          color: #b5b5b5;
          margin-top: 8px;
        }
        .testo {
          width: calc(100% - 30px);
          float: left;
          .link-url {
            display: block;
            float: left;
            width: 100%;
            height: 20px;
            .set-font(@size: 14px; @color: @greenRiva; @family: 'os-semibold');
            text-align: left;
            line-height: 20px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: uppercase;
          }
        .link-name {
          display: block;
          float: right;
          width: 100%;
          height: 20px;
          .set-font(@size: 13px; @color: #4040C5; @family: 'os-lightItalic');
          text-align: left;
          line-height: 20px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          text-transform: lowercase;
        }
        }
        
      }
      .linkDetail {
        height: 40px;
        line-height: 30px;
        position: relative;
        padding-bottom: 10px;
        display: flex;
        text-align: right;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-transform: lowercase;
        a {
        .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');
        .applicazione {
          text-transform: uppercase;
          .set-font(@size: 14px, @color: #485eb5, @weight: bold, @family:'os-regular');
        }
        .url {
          text-transform: lowercase;
          .set-font(@size: 13px; @color: @grayTesto; @family: 'os-lightitalic');
        }
        }
        a:hover {
          text-decoration: none;
        }
        a:focus {
          text-decoration: none;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage/LinkUtili.vue